/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkoutRating
 */
export interface WorkoutRating {
    /**
     * 
     * @type {number}
     * @memberof WorkoutRating
     */
    effort: number;
    /**
     * 
     * @type {number}
     * @memberof WorkoutRating
     */
    enjoyment: number;
    /**
     * 
     * @type {string}
     * @memberof WorkoutRating
     */
    note?: string;
}

/**
 * Check if a given object implements the WorkoutRating interface.
 */
export function instanceOfWorkoutRating(value: object): value is WorkoutRating {
    if (!('effort' in value) || value['effort'] === undefined) return false;
    if (!('enjoyment' in value) || value['enjoyment'] === undefined) return false;
    return true;
}

export function WorkoutRatingFromJSON(json: any): WorkoutRating {
    return WorkoutRatingFromJSONTyped(json, false);
}

export function WorkoutRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkoutRating {
    if (json == null) {
        return json;
    }
    return {
        
        'effort': json['effort'],
        'enjoyment': json['enjoyment'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function WorkoutRatingToJSON(json: any): WorkoutRating {
    return WorkoutRatingToJSONTyped(json, false);
}

export function WorkoutRatingToJSONTyped(value?: WorkoutRating | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effort': value['effort'],
        'enjoyment': value['enjoyment'],
        'note': value['note'],
    };
}

